import React from "react";
import { ExternalLink as ExternalLinkIcon } from "lucide-react";

interface MessageExternalLinksProps {
  links?: Array<{ url: string; label: string }>;
}

/**
 * Bir turun sunduğu uygulama dışı bağlantı şeridi (kargo takip, fatura,
 * satıcı sayfası).
 *
 * Hem canlı stream hem history aynı görünümü kullansın diye ayrı bir
 * component: bağlantılar stream sırasında `external_link` event'iyle,
 * yenilemeden sonra ise kaydedilmiş mesajdan geliyor — kullanıcı açısından
 * ikisi arasında görünür bir fark olmamalı.
 */
export const MessageExternalLinks: React.FC<MessageExternalLinksProps> = ({
  links,
}) => {
  if (!links || links.length === 0) return null;

  return (
    <div className="flex justify-start">
      <div
        data-chat-bubble="assistant"
        className="max-w-[90%] md:max-w-[80%] flex flex-wrap gap-2 px-4"
      >
        {links.map((link, index) => (
          <a
            key={`${link.url}-${index}`}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg border border-border-secondary dark:border-gray-700 bg-bg-primary dark:bg-gray-800 text-sm font-medium text-text-secondary dark:text-gray-200 hover:border-border-primary dark:hover:border-gray-600 hover:bg-bg-secondary dark:hover:bg-gray-700 transition-colors"
          >
            <ExternalLinkIcon className="h-3.5 w-3.5 flex-shrink-0" />
            {link.label}
          </a>
        ))}
      </div>
    </div>
  );
};
